export const WORKER_TYPES = {
  REGULAR_MEMBER: 0,
  SPOT_MEMBER: 1,
} as const
